module.exports = __webpack_public_path__ + "static/media/station-shop@2x.2d2ef5f2.png";